import { Fade } from './animation';

export { Fade };
